import { Container, Card } from 'react-bootstrap';

export default function PrivacyPolicy() {
  return (
    <div className="bg-light min-vh-100 py-5">
      <Container>
        <Card className="shadow-sm">
          <Card.Body className="p-4 p-md-5">
            <h1 className="h3 fw-bold mb-3">Privacy Policy</h1>
            <p className="text-muted mb-4">
              SupplyPassport OÜ (“we,” “us,” or “our”) is committed to protecting
              your privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you visit our
              website <strong>SupplyPassport.app</strong> and use our supplier risk
              management services.
            </p>

            <h2 className="h5 fw-semibold mt-4">1. Data Controller</h2>
            <p>
              SupplyPassport OÜ, registered in Tallinn, Estonia, is the data
              controller responsible for your personal data. For any
              privacy-related inquiries, you may contact us at
              <strong> info@supplypassport.co</strong>.
            </p>

            <h2 className="h5 fw-semibold mt-4">2. Information We Collect</h2>
            <p>
              We collect information that you provide directly to us, including:
            </p>
            <ul>
              <li>
                <strong>Account Data:</strong> Name, email address, job title,
                and company details.
              </li>
              <li>
                <strong>Supplier Data:</strong> Information you upload regarding
                your suppliers for risk assessment.
              </li>
              <li>
                <strong>Usage Data:</strong> IP addresses, browser types, and
                interaction data collected via cookies and similar technologies.
              </li>
            </ul>

            <h2 className="h5 fw-semibold mt-4">
              3. Legal Basis for Processing
            </h2>
            <p>Under the GDPR, we process your data based on:</p>
            <ul>
              <li>
                <strong>Contractual Necessity:</strong> To provide the services
                you signed up for.
              </li>
              <li>
                <strong>Legal Obligation:</strong> To comply with tax,
                accounting, and anti-fraud laws.
              </li>
              <li>
                <strong>Legitimate Interests:</strong> To improve our platform
                and ensure network security.
              </li>
              <li>
                <strong>Consent:</strong> Where you have explicitly agreed to
                receive marketing communications.
              </li>
            </ul>

            <h2 className="h5 fw-semibold mt-4">
              4. How We Use Your Information
            </h2>
            <p>
              We use your information to operate the SupplyPassport platform,
              process transactions, provide customer support, and send technical
              notices. We may also use anonymized, aggregated data to analyze
              industry trends and improve our risk models.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              5. Data Sharing and Disclosure
            </h2>
            <p>
              We do not sell your personal data. We may share information with:
            </p>
            <ul>
              <li>
                <strong>Service Providers:</strong> Cloud hosting (e.g.,
                AWS/Google Cloud) and payment processors.
              </li>
              <li>
                <strong>Legal Authorities:</strong> When required by Estonian or
                EU law.
              </li>
              <li>
                <strong>Business Transfers:</strong> In connection with a merger
                or sale of company assets.
              </li>
            </ul>

            <h2 className="h5 fw-semibold mt-4">6. Data Retention</h2>
            <p>
              We retain your personal data only as long as necessary to fulfill
              the purposes outlined in this policy or as required by law
              (typically 7 years for financial records under Estonian law).
            </p>

            <h2 className="h5 fw-semibold mt-4">7. Your GDPR Rights</h2>
            <p>
              As a resident of the European Economic Area (EEA), you have the
              right to:
            </p>
            <ul>
              <li>Access, update, or delete the information we have on you.</li>
              <li>Object to or restrict the processing of your data.</li>
              <li>
                Data portability (requesting a copy of your data in a structured
                format).
              </li>
              <li>Withdraw consent at any time.</li>
            </ul>

            <h2 className="h5 fw-semibold mt-4">8. Security</h2>
            <p>
              We implement industry-standard technical and organizational
              measures to protect your data. However, no method of transmission
              over the Internet is 100% secure, and we cannot guarantee absolute
              security.
            </p>

            <h2 className="h5 fw-semibold mt-4">9. Cookies</h2>
            <p>
              We use cookies to enhance your experience and analyze traffic. You
              can control cookie settings through your browser, though some
              features of SupplyPassport may not function correctly without them.
            </p>

            <h2 className="h5 fw-semibold mt-4">10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new policy on this page
              and updating the "Last Updated" date.
            </p>

            <h2 className="h5 fw-semibold mt-4">11. Contact Us</h2>
            <p className="mb-0">
              If you have any questions about this Privacy Policy or wish to
              exercise your rights, please reach out to our Data Protection team
              at:
              <br />
              <strong>Email:</strong> info@supplypassport.co
              <br />
              <strong>Address:</strong> SupplyPassport OÜ, Tallinn, Estonia
            </p>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
